import { Form, FormItem, FormSubmitHandler, TextInput, isMobileView } from "@sis/react-library"
import { FeedbackDto } from "./FormSamplesWithinDialogPage";
import { useEffect, useRef } from "react";
import { Stack } from "@mui/material";

/////////////////////////////////////////////////////////////////////////////////////////////
// Showing the different controls in the library
// you can pass a disabled prop into any control for readonly mode
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends FeedbackDto { }

interface FormSamplesWithinDialogFormProps {
    formName: string;
    onSubmit: FormSubmitHandler<FeedbackDto>;
    submitting: boolean;
    open: boolean;
}

export const FormSamplesWithinDialogForm = ({
    formName, onSubmit, submitting, open
}: FormSamplesWithinDialogFormProps) => {

    const isMobile = isMobileView();
    const userNameRef = useRef<HTMLElement>(undefined);

    useEffect(() => {
        // This is the way to do an auto focus in a dialog, the autofocus prop on TextInput won't work 
        // The example below does autofocus only on 
        // desktop as on mobile the keyboard opening up straight away looks strange to me 
        if (open && !isMobile && userNameRef?.current != null) {
            userNameRef.current.focus();
        }
    }, [open, isMobile])

    return (
        // No need for the beforeLeaveText as the dialog forces the user to submit or cancel
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            submitButtonOutsideForm  // Tells the form submit button is not in this form, so pressing Enter on a field will still submit the form
        >
            <Stack direction={isMobile ? "column" : "row"} spacing={isMobile ? 0 : 4}>
                <FormItem<T>
                    formField="name"
                    label="Name"
                    rules={[
                        { type: "required", message: "This field is required!" },
                        { type: "minLength", value: 3, message: "Must be at least 3 characters!" }
                    ]}
                    element={<TextInput maxLength={50} inputRef={userNameRef} />}
                />
                <FormItem<T>
                    formField="surname"
                    label="Surname"
                    rules={[
                        { type: "required", message: "This field is required!" },
                        { type: "minLength", value: 3, message: "Must be at least 3 characters!" }
                    ]}
                    element={<TextInput maxLength={50} />}
                />
            </Stack>
            <FormItem<T>
                formField="feedback"
                label="Feedback"
                noFeedback
                rules={[
                    { type: "required", message: "This field is required!" }
                ]}
                element={
                    <TextInput
                        variant="outlined"
                        multiline
                        rows={4}
                    />
                }
            />
            <FormItem<T>
                formField="email"
                label="Email"
                rules={[
                    { type: "required", message: "This field is required!" },
                    { type: "email", message: "Must be an email address!" }
                ]}
                element={<TextInput maxLength={50} />}
            />
        </Form>
    )
}